document.addEventListener("DOMContentLoaded", function () {
  // モーダルを開く
  document.querySelectorAll(".p-about-us-map__item").forEach((item) => {
    item.addEventListener("click", function () {
      const modalId = this.getAttribute("data-modal");
      const modal = document.getElementById(modalId);
      if (modal) {
        modal.classList.add("c-modal-open"); // クラスを追加して表示
      }
    });
  });

  // モーダルを閉じる
  document.querySelectorAll(".c-modal-close").forEach((closeButton) => {
    closeButton.addEventListener("click", function () {
      this.closest(".c-modal").classList.remove("c-modal-open"); // クラスを削除して非表示
    });
  });

  // モーダルの外側をクリックした場合も閉じる
  document.querySelectorAll(".c-modal").forEach((modal) => {
    modal.addEventListener("click", function (event) {
      if (event.target === modal) {
        modal.classList.remove("c-modal-open"); // クラスを削除して非表示
      }
    });
  });
});
